export {
    default as GmailSVG
} from './GmailIcon.svg';

export {
    default as OutlookSVG
} from './OutlookIcon.svg'
